import { render, staticRenderFns } from "./ItemFilterHoldingLayout.vue?vue&type=template&id=2b35d3d6&scoped=true"
import script from "./ItemFilterHoldingLayout.vue?vue&type=script&lang=js"
export * from "./ItemFilterHoldingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b35d3d6",
  null
  
)

export default component.exports